import { shapes } from '@joint/plus';
import React, { ChangeEvent, ReactElement, useCallback, useEffect, useState } from 'react';

import Input from '../Input/Input';
import Select from '../Input/Select/Select';
import { useBaseInspector } from './useBaseInspector';

import ReactQuill from 'react-quill';

import { getCategoriesByOrganization, getOrganizations } from '../../../services/organization.service';
import HelperCustomField from '../../HelperCustomField/HelperCustomField';
import { Switch } from '@mui/material';
import GroupedSelect from '../Input/GroupedSelect';
import { getVariablesAndCustomFields } from '../../../services/chatbotflow.service';
import * as ParamsService from "../../../../../../../../services/2talk/chatbotResponseParams.service";

interface Props {
    cell: shapes.app.CreateTicket;
    chatbotFlowId: string;
}

const cellProps = {
    label: ['attrs', 'label', 'text'],
    description: ['attrs', 'description', 'text'],
    icon: ['attrs', 'icon', 'xlinkHref'],
    portLabel: ['attrs', 'portLabel', 'text'],
    isTextRich: ['attrs', 'isTextRich', 'isTextRich'],
    organizationId: ['attrs', 'organizationId', 'id'],
    categoryId: ['attrs', 'categoryId', 'id'],
    titleParamId: ['attrs', 'titleParamId', 'id'],
    descriptionParamId: ['attrs', 'descriptionParamId', 'id'],

    isDinamycOrganizationAndCategory: ['attrs', 'isDinamycOrganizationAndCategory', 'isDinamycOrganizationAndCategory'],
    
    
    organizationIdDinamyc: ['attrs', 'organizationIdDinamyc', 'id'],
    organizationIdTypeDinamyc: ['attrs', 'organizationIdDinamyc', 'type'],
    
    categoryIdDynamic: ['attrs', 'categoryIdDynamic', 'id'],
    categoryIdTypeDynamic: ['attrs', 'categoryIdDynamic', 'type'],
};

const CreateTicketInspector = (props: Props): ReactElement => {

  const { cell, chatbotFlowId } = props;

  const [organizationOptions, setOrganizationOptions] = useState([]);
  const [organizationCategoryOptions, setOrganizationCategoryOptions] = useState([]);

  const [label, setLabel] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [isTextRich, setIsTextRich] = useState<boolean>(false);
  const [organizationId, setOrganizationId] = useState(null);
  const [categoryId, setCategoryId] = useState(null);


  const [titleParamId, setTitleParamId] = useState(null);
  const [descriptionParamId, setDescriptionParamId] = useState(null);

  const [isDinamycOrganizationAndCategory, setIsDinamycOrganizationAndCategory] = useState<boolean>(false);
  
  const [organizationIdDinamyc, setOrganizationIdDinamyc] = useState(null);
  const [organizationIdTypeDinamyc, setOrganizationIdTypeDinamyc] = useState('');
  
  const [categoryIdDynamic, setCategoryIdDynamic] = useState(null);
  const [categoryIdTypeDynamic, setCategoryIdTypeDynamic] = useState('');

  const [variablesAndCustomFields, setVariablesAndCustomFields] = useState([]);


  const [paramsOptions, setParamsOptions] = useState([]);

  const assignFormFields = useCallback(async (): Promise<void> => {
      setLabel(cell.prop(cellProps.label));
      setDescription(cell.prop(cellProps.description));
      setIsTextRich(cell.prop(cellProps.isTextRich));
      setOrganizationId(cell.prop(cellProps.organizationId));
      setCategoryId(cell.prop(cellProps.categoryId));


      setTitleParamId(cell.prop(cellProps.titleParamId));
      setDescriptionParamId(cell.prop(cellProps.descriptionParamId));

      setIsDinamycOrganizationAndCategory(cell.prop(cellProps.isDinamycOrganizationAndCategory));

      if (cell.prop(cellProps.isDinamycOrganizationAndCategory) == false) {
        resetValuesDinamic();
      }

      setOrganizationIdDinamyc(cell.prop(cellProps.organizationIdDinamyc));
      setOrganizationIdTypeDinamyc(cell.prop(cellProps.organizationIdTypeDinamyc));

      setCategoryIdDynamic(cell.prop(cellProps.categoryIdDynamic));
      setCategoryIdTypeDynamic(cell.prop(cellProps.categoryIdTypeDynamic));

      if (cell.prop(cellProps.organizationId)) {
        await fetchOrganizationCategory(cell.prop(cellProps.organizationId));
      }
  }, [cell]);

  const changeCellProp = useBaseInspector({ cell, assignFormFields });

  const fetchOrganization = async () => {
    const organizations = await getOrganizations();
    setOrganizationOptions(organizations);
  }

  const fetchVariablesAndCustomFields = async () => {
    const data = await getVariablesAndCustomFields();
    setVariablesAndCustomFields(data ?? []);
  }

  const fetchOrganizationCategory = async (orgId: number) => {
    const categories = await getCategoriesByOrganization(orgId);
    setOrganizationCategoryOptions(categories);
  }

  const changeOrganization = async (orgId: any) => {
    setCategoryId(null);
    changeCellProp(cellProps.organizationId, orgId);
    await fetchOrganizationCategory(orgId);
  }

  const changeOrganizationDinamyc = async (organizationDinamicSelected: any) => {
    changeCellProp(cellProps.organizationIdDinamyc, organizationDinamicSelected?.id);
    changeCellProp(cellProps.organizationIdTypeDinamyc, organizationDinamicSelected?.type);
  }

  const changeCategoryDinamyc = async (categoryDinamicSelected: any) => {
    changeCellProp(cellProps.categoryIdDynamic, categoryDinamicSelected?.id);
    changeCellProp(cellProps.categoryIdTypeDynamic, categoryDinamicSelected?.type);
  }

  const resetValuesDinamic = () => {
    changeCellProp(cellProps.organizationIdDinamyc, null);
    changeCellProp(cellProps.organizationIdTypeDinamyc, "");
    changeCellProp(cellProps.categoryIdDynamic, null);
    changeCellProp(cellProps.categoryIdTypeDynamic, "");
  }

  const fetchParams = async () => {
        const params = await ParamsService.getAll();
        setParamsOptions(params?.data ?? []);
  }


  useEffect(() => {

      const onLoadData = async () => {
            await fetchParams();
            await fetchOrganization();
            await fetchVariablesAndCustomFields();
      }

      onLoadData();

  }, []);

  return (
      <>
          <h1>Componente selecionado</h1>

          <label>Label
              <Input type="text"
                      placeholder="Enter label"
                      value={label}
                      disabled={true}
              />
          </label>

          <div style={{ marginBottom: '8px', marginTop: '8px'}}>
            <Switch
                value={isTextRich}
                checked={isTextRich}
                onChange={(e:any) => changeCellProp(cellProps.isTextRich, e?.target?.checked)}     
            />
            <label>É um texto rico?</label>
          </div>

          {
              isTextRich
              ? (
                
                  <label>Descrição
                    <div style={{ resize: "vertical", overflow: "auto", height: "250px", marginBottom: "24px", border: "1px solid #ccc" }}>
                      <ReactQuill
                          style={{ height: '100%' }}
                          name="description"
                          fullWidth
                          variant="outlined"
                          id="descriprion"
                          value={description}
                          onChange={(value: any) => changeCellProp(cellProps.description, value)}
                      />
                    </div>
                  </label>
              )
              : (
                  <label>Descrição
                      <Input 
                          type="text"
                          placeholder="Enter description"
                          value={description}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => changeCellProp(cellProps.description, e.target.value)}
                      />
                  </label>
              )
          }

            <label>Parâmetro para título do chamado
                <Select
                    value={titleParamId}
                    onChange={(e) => changeCellProp(cellProps.titleParamId, e.target.value)}
                    options={paramsOptions}
                />
            </label>

            <label>Parâmetro para descrição do chamado
                <Select
                    value={descriptionParamId}
                    onChange={(e) => changeCellProp(cellProps.descriptionParamId, e.target.value)}
                    options={paramsOptions}
                />
            </label>



          <HelperCustomField
            isRichText={isTextRich}
            description={description}
            param1={cellProps.description}
            onChangeDescription={changeCellProp}
            chatbotFlowId={chatbotFlowId}
          />


          <div style={{ marginBottom: '8px', marginTop: '8px', display: 'flex', alignItems: 'center', gap: '2px'}}>
            <Switch
                value={isDinamycOrganizationAndCategory}
                checked={isDinamycOrganizationAndCategory}
                onChange={(e:any) => changeCellProp(cellProps.isDinamycOrganizationAndCategory, e?.target?.checked)}     
            />
            <label>A organização e categoria serão carregados dinamicamentes?</label>
          </div>

          {
            isDinamycOrganizationAndCategory
            ? <>
                <label>Organização dinamica
                  <GroupedSelect 
                    options={variablesAndCustomFields} 
                    value={
                      {
                        id: organizationIdDinamyc,
                        type: organizationIdTypeDinamyc
                      }
                    }
                    onChange={(e) => changeOrganizationDinamyc(e.target.value)}
                  />
                </label>

                <label>Categoria dinamica
                  <GroupedSelect 
                    options={variablesAndCustomFields} 
                    value={
                      {
                        id: categoryIdDynamic,
                        type: categoryIdTypeDynamic
                      }
                    }
                    onChange={(e) => changeCategoryDinamyc(e.target.value)}
                  />
                </label>  
              </>
            : (
              <>
                <label>Organização
                  <Select
                    value={organizationId}
                    onChange={(e) => changeOrganization(e.target.value)}
                    options={organizationOptions}
                  />
                </label>

                <label>Categoria
                  <Select
                    value={categoryId}
                    onChange={(e) => changeCellProp(cellProps.categoryId, e.target.value)}
                    options={organizationCategoryOptions}
                  />
                </label>
              </>
            )
          } 
      </>
  );
};

export default CreateTicketInspector;
